import React, { useState } from 'react';
import { images } from '../../constants';
import { RiDownload2Fill } from 'react-icons/ri'
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../Client';
import './Footer.scss'

const Footer = () => {

  const downloadFile = () => {
    fetch("Pelumi_Martins_Resume.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Pelumi_Martins_Resume.pdf";
        alink.click();
      });
    });
  }

  const [formData, setFormData] = useState({name: '', email: '', message: ''});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;
  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  }
  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message,
    }

    client.create(contact)
      .then(() => {
         setLoading(false);
         setIsFormSubmitted(true);
      })
  }

  return (
    <>
      <h2 className="head-text">
        Take a coffee & <span>chat with me</span>
      </h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:pelumimartins5@gmail.com" className="p-text">
            pelumimartins5@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.phone1} alt="mobile" />
          <a href="tel: +234 7013940026" className="p-text">
            +234 7013940026
          </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>
            {" "}
            {!loading ? "Send Message" : "Sending..."}{" "}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch</h3>
        </div>
      )}
      <div className='download'>
         <button value='download' onClick={downloadFile}>
           <RiDownload2Fill/>
         </button>
         <h3 className='bold-text'>Download Resume</h3>
      </div>
    </>
  );
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__bg'
)